module.exports = __webpack_public_path__ + "media/images/advertise/spice_theory_email-c40500d0c57b60e9e1f1f697b9bf81e6.png";